import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import ADLInterface, { NavRequest, NavRequestValid } from "@/lib/ScormApi/Scorm2004/interfaces/ADLInterface"

function adlNavRequestValidChoice (_target: any) {
  return 'unknown'
}

function adlNavRequestValidJump (_target: any) {
  return 'unknown'
}

export default function ADL (api: ScormAPI2004): ADLInterface {
  let _request = NavRequest.NONE
  let _continue = NavRequestValid.UNKNOWN
  let _previous = NavRequestValid.UNKNOWN

  return {
    nav: {
      get request () {
        return _request;
      },
      set request (request) {
        _request = request
      },
      request_valid: {
        get continue () {
          return _continue
        },
        set continue (_) {
          api.throwSCORMError(404)
        },
        get previous () {
          return _previous
        },
        set previous (_) {
          api.throwSCORMError(404)
        },
        choice: {
          _isTargetValid: adlNavRequestValidChoice
        },
        jump: {
          _isTargetValid: adlNavRequestValidJump
        }
      }
    }
  }
}
